import * as React from "react";
import type { SVGProps } from "react";
const SvgWeb3AssetsIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    className="web3_assets_icon_svg__icon"
    viewBox="0 0 1024 1024"
    {...props}
  >
    <path
      fill="currentColor"
      d="M170.667 85.333a128 128 0 0 0-128 128v597.334a128 128 0 0 0 128 128h682.666a128 128 0 0 0 128-128V213.333a128 128 0 0 0-128-128H170.667zM896 384H746.667a149.333 149.333 0 1 0 0 298.667H896v128a42.667 42.667 0 0 1-42.667 42.666H170.667A42.667 42.667 0 0 1 128 810.667V213.333a42.667 42.667 0 0 1 42.667-42.666h682.666A42.667 42.667 0 0 1 896 213.333V384zm0 213.333H746.667a64 64 0 0 1 0-128H896v128z"
    />
  </svg>
);
export default SvgWeb3AssetsIcon;
